(function(root){
  function deliveryWindow(now,locale){
    now=now||new Date();
    var start=new Date(now.getFullYear(),now.getMonth(),now.getDate()+4,12);
    var end=new Date(now.getFullYear(),now.getMonth(),now.getDate()+8,12);
    var options={month:'short',day:'numeric'};
    if(end.getFullYear()!==now.getFullYear()) options.year='numeric';
    var format;
    try{format=new Intl.DateTimeFormat(locale||'en',options);}catch(e){format=new Intl.DateTimeFormat('en',options);}
    function iso(date){return date.getFullYear()+'-'+String(date.getMonth()+1).padStart(2,'0')+'-'+String(date.getDate()).padStart(2,'0');}
    return {start:iso(start),end:iso(end),label:format.formatRange?format.formatRange(start,end):format.format(start)+' – '+format.format(end)};
  }
  if(typeof module==='object'&&module.exports) module.exports=deliveryWindow;
  else root.HSCartDelivery=deliveryWindow;
})(typeof window==='object'?window:this);
